import { Link } from 'react-router-dom';
import { styled } from '@mui/material';

import ActionButton from '@components/ActionButton';

export const sxStyles = {
  heroWrap: {
    overflow: 'hidden',
  },
  heroTitle: {
    marginTop: '1rem',
  },
  heroSubtitle: {
    marginTop: '1.5rem',
    lineHeight: '2rem',
    fontSize: '1.25rem',
  },
  contentWrap: {
    // TODO add color to library
    backgroundColor: '#F9F9F9',
  },
};

export const StyledHeroSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'end',
  maxWidth: '1320px',
  margin: '0 auto',
  position: 'relative',

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export const StyledHeroText = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '620px',
  width: '100%',
  minHeight: 'auto',
  padding: '1.25rem',

  [theme.breakpoints.up('sm')]: {
    minHeight: '480px',
  },
}));

export const StyledHeaderActionsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '1.5rem',
  marginBottom: '2rem',

  '& > button:first-of-type': {
    marginRight: '0.5rem',
  },

  [theme.breakpoints.up('sm')]: {
    justifyContent: 'start',
  },
}));

export const StyledAddAreaBtn = styled(ActionButton)(() => ({
  maxWidth: '224px',
  width: '100%',
  height: '48px',
  fontSize: '1rem',

  '& > svg:first-of-type': {
    marginRight: '0.5rem',
  },
}));

export const StyledPreviewBtn = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '224px',
  width: '100%',
  height: '48px',
  padding: '0.75rem',
  borderRadius: '2px',
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  fontWeight: 600,
  textAlign: 'center',
  transition: 'background-color 0.5s',

  '&:hover': {
    // TODO add color to library
    backgroundColor: '#EBF6F7',
  },

  '& > svg:first-of-type': {
    marginRight: '0.5rem',
  },
}));

export const StyledUpdateImageBtn = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: '1rem',
  right: '28%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '224px',
  width: '100%',
  height: '48px',
  borderRadius: '2px',
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  fontWeight: 600,
  transition: 'background-color 0.5s',

  '&:hover': {
    // TODO add color to library
    backgroundColor: '#EBF6F7',
    cursor: 'pointer',
  },

  '& > svg:first-of-type': {
    marginRight: '0.5rem',
  },

  [theme.breakpoints.up('sm')]: {
    right: '38%',
  },

  [theme.breakpoints.up('lg')]: {
    right: '5%',
  },

  [theme.breakpoints.up('xl')]: {
    right: '-28%',
  },
}));

export const StyledHeroImg = styled('div')(({ theme }) => ({
  position: 'relative',
  maxWidth: '850px',
  width: '100%',
  margin: '1.5rem auto 0 auto',

  img: {
    position: 'static',
    display: 'block',
    margin: '0 auto',
    borderBottomLeftRadius: '240px',
    maxHeight: '480px',
    height: '100%',
  },

  [theme.breakpoints.up('lg')]: {
    width: '850px',
    margin: '0',

    img: {
      position: 'relative',
      left: '74px',
    },
  },

  [theme.breakpoints.up('xl')]: {
    img: {
      position: 'relative',
      left: '256px',
    },
  },
}));

export const StyledEmptyStateText = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '920px',
  width: '100%',
  minHeight: '250px',
  textAlign: 'center',
  padding: '0 1.25rem',
  margin: '0 auto',

  '& > h1:first-of-type': {
    margin: '2.5rem 0',
  },

  [theme.breakpoints.up('sm')]: {
    minHeight: '400px',
  },
}));
